import React from "react";
import UserProfileSidebarQuickActions from "./UserProfileSidebarQuickActions";

/**
 * UserProfileSidebarSidepanel component
 * Contains the left sidepanel with quick action icons
 * @author Bhavana
 */
const UserProfileSidebarSidepanel = () => {
  return (
    <div className="sidepanel-quick-actions text-center d-flex flex-column align-items-center justify-content-center my-4">
      <UserProfileSidebarQuickActions />
    </div>
  );
};

export default UserProfileSidebarSidepanel;

